/**
 * Created by Josef Jurca on 25.7.2017.
 */


class Bookmark {

    /**
     * Constructs the instance.
     *
     * @param {Object} [options] - Options object.
     */
    constructor (options = {}) {

        this.id = options.id || null;
        this.type = options.type || '';
        this.finishedWatching = options.finishedWatching || false;
        this.position = options.position || 0;
        this.apiSpecific = options.apiSpecific || {};

        return this;
    }
}

export default Bookmark;


// WEBPACK FOOTER //
// ./src/js/models/bookmark.js